// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import articleReviewEntity from './entities/article-review.json';
import articleReviewMenu from '../pages/article-review/menu.json';
import articleReviewFullForm from '../pages/article-review/forms/full.json';
import articleReviewContextForm from '../pages/article-review/forms/context.json';
import articleReviewMiniForm from '../pages/article-review/forms/mini.json';
import articleReviewLookupForm from '../pages/article-review/forms/lookup.json';
import articleReviewTableView from '../pages/article-review/views/table.json';
import articleReviewCardsView from '../pages/article-review/views/cards.json';
import articleReviewCalendarView from '../pages/article-review/views/calendar.json';
import articleReviewDashboardView from '../pages/article-review/views/dashboard.json';

/** Тип запису «Перегляд статті» зі сторінками пакета: меню, форми та подання з pages/article-review/. */
export const articleReviewDefinition: IRecordTypeDefinition = {
  ...articleReviewEntity,
  views: assembleViewSet({
      table: articleReviewTableView,
      cards: articleReviewCardsView,
      calendar: articleReviewCalendarView,
      dashboard: articleReviewDashboardView,
  }),
  form: articleReviewFullForm,
  forms: { full: articleReviewFullForm, context: articleReviewContextForm, mini: articleReviewMiniForm, lookup: articleReviewLookupForm },
  menu: articleReviewMenu,
} as IRecordTypeDefinition;
